// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"16eddc9f","455":"3c04b5a5","977":"d64a6275"}[chunkId] + ".chunk.js";
};